import React from 'react'
import styled from 'styled-components'
import { find, get } from 'lodash'
import { mediaQueries, SelectLayout } from '@blazar-plugins/device'
import PropTypes from 'prop-types'
import { Link } from 'blocket-ui'
import SideScroll from 'components/SideScroll'

const Wrapper = styled.aside`
  padding-bottom: 16px;
  background-color: #f9f7f6;

  @media ${mediaQueries.large} {
    width: 980px;
    margin: auto;
  }
`

const LinksWrapper = styled.ul`
  padding: 16px 0 24px;

  li {
    margin-bottom: 8px;
    display: inline-block;
  }
`

const Headline = styled.h2`
  font-size: 22px;
  font-family: BlocketSans-Medium, sans-serif;
  color: #363433;
  padding: 0 16px;

  @media ${mediaQueries.large} {
    padding: 0;
  }
`

const StyledLink = styled(Link)`
  color: #363433;
  font-size: 15px;

  &:hover {
    color: #363433;
  }
`

export const QuickLinks = ({ inventory }) => {
  let links

  if (inventory && inventory.placements) {
    const seoLinks = find(
      inventory.placements,
      (placement) => placement.type === 'seo_links' && placement.vendor === 'blocket',
    )
    links = get(seoLinks, 'seo_links')
  }

  if (!links) {
    return null
  }

  const child = (
    <>
      <Headline>Snabblänkar</Headline>
      <LinksWrapper>
        {links.map(({ label, url }, index) => (
          <li key={label}>
            <StyledLink to={url}>{label} </StyledLink>
            {links.length - 1 !== index && <>&nbsp;·&nbsp;</>}
          </li>
        ))}
      </LinksWrapper>
    </>
  )

  return (
    <Wrapper>
      <SelectLayout
        layouts={{
          large: child,
          small: (
            <SideScroll listStyle="padding: 4px 16px" listStyleLarge="padding: 0">
              {child}
            </SideScroll>
          ),
        }}
      />
    </Wrapper>
  )
}

QuickLinks.propTypes = {
  inventory: PropTypes.object.isRequired,
}

export default QuickLinks
